import { render, staticRenderFns } from "./SdeptSerOrder.vue?vue&type=template&id=4cb11d95&"
import script from "./SdeptSerOrder.vue?vue&type=script&lang=ts&"
export * from "./SdeptSerOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports